import { jsx } from "react/jsx-runtime";
import { Code, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BlockCode = ({
  attrs
}) => {
  const {
    content = "",
    language,
    ...rest
  } = attrs;
  if (!content || !content.trim()) {
    return null;
  }
  const finalLanguage = language || DEFAULT_LANGUAGE;
  return /* @__PURE__ */ jsx(Code, { content, language: finalLanguage, ...rest });
};
BlockCode.propTypes = {
  attrs: PropTypes.shape({
    content: PropTypes.string,
    language: PropTypes.oneOf([...SUPPORTED_LANGUAGES])
  }),
  index: PropTypes.number
};
export {
  BlockCode as default
};
